<template>
    <div id="theContainer" class="">
        <div>
            <button id="menuBtn" @click="showMenu()">
                <svg id="chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="chevron-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                </svg>
            </button>
        </div>
        <div id="container-btn" class="flex-column-center">
            <button class="btn1" @click="coller()">Coller</button>
            <button class="btn1" @click="codage">Codage</button>
            <button class="btn1" @click="copier()">Copier</button>
            <button class="btn1">Impression</button>
            <button class="btn1" @click="ecrire()">Ecriture</button>
            <button class="btn1" @click="decodage()">Décodage</button>
        </div>
    </div>

    <div class="flex-row-center">
        <div class="container-flic32 flex-column-center">
            <div class="flex-row-center conainter-numlicence">
                <div id="flic32-numlicence-column1">
                    <div>1</div>
                    <div><input class="input-numlicence" id="input-numlicence1" v-model="licencePart1" type="text" /></div>
                </div>
                <div id="flic32-numlicence-column2">
                    <div>2</div>
                    <div>-<input class="input-numlicence" id="input-numlicence2" v-model="licencePart2" type="text" /></div>
                </div>
                <div id="flic32-numlicence-column3">
                    <div>3</div>
                    <div>-<input class="input-numlicence" id="input-numlicence3" v-model="licencePart3" type="text" /></div>
                </div>
                <div id="flic32-numlicence-column4">
                    <div>4</div>
                    <div>-<input class="input-numlicence" id="input-numlicence4" v-model="licencePart4" type="text" /></div>
                </div>
            </div>

            <div class="flic32-containerbtn">
                <button class="btn-flic32" @click="coller()">Coller</button>
                <button class="btn-flic32" @click="codage">Codage</button>
                <button class="btn-flic32" @click="copier()">Copier</button>
                <button class="btn-flic32" @click="imprimer()">Impression</button>
                <button class="btn-flic32" @click="ecrire()">Ecriture</button>
                <button class="btn-flic32" @click="decodage()">Décodage</button>
            </div>
            <!--<div class="flex-row-end">
                <button id="flic32-btnMenu" @click="showMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                    </svg>
                </button>
            </div>-->
            <!--<div id="flic32-background-menu" @click="showMenu()">
            </div>
            <div>
                <div id="flic32-container-btn-phone" class="flex-column-center">
                    <button class="btn-flic32-phone" @click="coller()">Coller</button>
                    <button class="btn-flic32-phone" @click="codage">Codage</button>
                    <button class="btn-flic32-phone" @click="copier()">Copier</button>
                    <button class="btn-flic32-phone">Impression</button>
                    <button class="btn-flic32-phone" @click="ecrire()">Ecriture</button>
                    <button class="btn-flic32-phone" @click="decodage()">Décodage</button>
                </div>
            </div>
            <div id="flic32-croix-closeMenu">
                <input @click="showMenu()" type="image" src='/images/croix.png' alt="submit" width="30" height="30" style="font-size:14px;padding:0;margin:0" />
            </div>-->

            <div class="flex-row-center">
                <div class="description-flic32">
                    <div class="recherche flic32-row flex-row-space">
                        <label class="flic32-label">Client:</label>
                        <input id="inputRechercheFlic32" class="flic32-row flic32-ficheDescr-input" v-model="critere" type="search" v-on:keyup="chercher()" v-on:focus="showPrat()" v-on:blur="showPrat()" />
                        <div class="resultatRecherche flex-column-center">
                            <p class="select-prat" v-for="nom in lesNomPrat" :key="nom" @mousedown="changerContratParNom(nom)">{{nom}}</p>
                        </div>
                    </div>
                    <div class="flic32-row flex-row-space">
                        <label class="flic32-label">N° de série</label>
                        <div class="flic32-ficheDescr-input">
                            <input id="inputNumSerie" class="input-numserie" :maxlength="8" v-model="NUMERO_SERIE" type="text" onfocus="focusInput(element)" v-on:blur="focusInput(element)" />
                            <button v-on:click="toLeft" style="width: 6%; margin-right: 7%; margin-left: 7%">&lt;</button>
                            <input class="input-numserie" :maxlength="8" v-model="NUMERO_SERIE2" type="text" />
                        </div>
                    </div>
                    <div class="flic32-row flex-row-space">
                        <label class="flic32-label">Produit:</label>
                        <select v-model="produitChoisit" class="flic32-row select-produit flic32-ficheDescr-input">
                            <option value="">Veuillez choisir un produit</option>
                            <option v-for="prod in lesProd">{{prod}}</option>
                        </select>
                    </div>
                    <div class="flex-column-start" style="margin-top:15px">
                        <div class="flex-row-space">
                            <label>Modules</label>
                            <div class="flex-row-space" style="display: inherit">
                                <button class="flic32-row flic32-btn-module" style="margin-right:15px" @click="selectAllModules(true)">Tous les modules</button>
                                <button class="flic32-row flic32-btn-module" @click="selectAllModules(false)">Aucun module</button>
                            </div>
                        </div>
                        <div class="flic32-container-module">
                            <p class="flic32-module" :class="{possede :possede[index]} " @click="selectModulePossede(index)" :value="index" style="margin-bottom: 0" v-for="(mod,index) in lesMod">{{mod}}</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<style>
    #theContainer{
        display: none;
        position: fixed;
        display: none;
        z-index: 40;

        flex-direction: row;
        justify-content: start;
        align-items: center;
        transition: ease-in .2s;
        /*right: -1rem;*/
    }
    #container-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: white;
        padding: 15px;
        border: solid 1px;
        border-radius: 15px 0 15px 0;
    }
    .btn1 {
        width: 100px;
        margin: 5px;
        border: solid 0.5px;
    }
    #menuBtn {
        border-radius: 40px 0 0 40px;
    }

    @media (max-width: 650px) {
        #menuBtn{
            display: block;
        }
        #theContainer{
            display: flex;
        }
    }
</style>
<style>
    .flex-row-start {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-content: start;
    }
    .flex-row-space {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: start;
    }
    .flex-column-start {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-content: start;
    }
    .flex-row-center {
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: center;
    }
    .flex-row-end {
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: end;
    }

    .flic32-row{
        /*justify-content: space-between;*/
    }
    .flic32-label{
        width: 25%;
        text-align: left;
    }

    .container-flic32 {
        padding: 50px;
        border: solid 1px;
        width: 50em;
        border-radius: 15px;
    }
    .conainter-numlicence{
        border: solid 0.2px;
        padding: 13px;
    }
    .input-numlicence {
        width: 86%;
    }

    .flic32-containerbtn{
        margin-top: 15px;
    }
    .btn-flic32{
        width: 16.6%;
        border-radius: 15px;
        /*margin: 1px;*/
        /*border: none;
        background-color: dodgerblue;
        color: white;*/
    }

    .description-flic32 {
        margin-top: 25px;
    }

    .flic32-ficheDescr-input{
        display: inline;
        width: 80%;
    }
    .input-numserie {
        width: 40%;
        background-color: deepskyblue;
    }

    #inputRechercheFlic32{
        height: 100%;
        background-color: deepskyblue;
    }
    .recherche{
        /*width: 33%;*/
    }
    .resultatRecherche {
        display: none;
        background-color: white;
        text-align: start;
        position: absolute;
        /*margin-top: 35px;*/
        /*transform: translate(54px, 31px);*/
        border: 0.5px solid;
        background-color: deepskyblue;
    }
    .resultatRecherche.show {
        display: block;
    }
    .select-prat {
        cursor: pointer;
        margin: 0;
        padding: 0;
        background-color: deepskyblue;
    }

    .flic32-container-module {
        background-color: white;
        overflow-y: auto;
        height: 330px;
    }
    .flic32-module {
        cursor: pointer;
    }
    .flic32-module:hover, .select-prat:hover {
        background-color: skyblue;
    }

    .btn-flic32:hover {
        background-color: snow;
    }

    .possede {
        background-color: dodgerblue;
    }
    .flic32-btn-module{
        width: auto;
        height: 30px;
        display: inline;
    }

    input[type=text]:focus, input[type=search]:focus {
        border: 3px solid dodgerblue;
    }

    /* MENU STYLE */
    #flic32-background-menu{
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        top: 0;
        right: 0;
        background: grey;
        z-index: 1;
        opacity: 0.25;
    }
    #flic32-background-menu.show {
        display: block;
    }

    #flic32-container-btn-phone {
        display: none;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        z-index: 2;
        background: white;
        width: 50%;
        position: fixed;
        padding: 30px;
        border-radius: 30px 0 30px 0;
        transition: ease-out.2s;
        border: solid 1px;
    }
    #flic32-btnMenu{
        z-index: 3;
    }
    #flic32-container-btn-phone.show {
        display: flex;
    }
    #flic32-croix-closeMenu{
        position: absolute;
        display: none;
        z-index: 3;
        /*background: red;*/
    }
    #flic32-croix-closeMenu.show{
        display: block;
    }
    #flic32-btnMenu{
        border-radius: 10px;
        position: fixed;
        /*left: 370px;*/
        transition: ease-in.2s;
        display: none;
    }
    #flic32-btnMenu.show{
        left: -100px;
    }
    .btn-flic32-phone{
        margin : 4px;
    }

    @media (max-width: 650px) {
        /*.container-flic32{
            width: 100em;
        }*/
        /*#input-numlicence3, #input-numlicence4 {
            width: 50%;
        }*/
        #flic32-numlicence-column3, #flic32-numlicence-column4 {
            width: 26%;
        }
        #flic32-numlicence-column1{
            width: 40%;
        }
        .conainter-numlicence{
            width: 125%;
            justify-content: start;
            align-content: start;
            font-size: 12px;
            transform: translate(-10%,0);
        }
        .input-numlicence{
            font-size: 14px;
        }
        .container-flic32 {
        }
        /*.flic32-numlicence-column{
            width: 300px
        }*/
        .flic32-containerbtn {
            display: none;
        }

        #flic32-container-btn-phone{
            display: flex;
        }
        #flic32-btnMenu{
            display: block;
        }
    }             
</style>

<script>
    import { watch } from 'vue';
    /* END EXTERNAL SOURCE */
    /* BEGIN EXTERNAL SOURCE */

    import { defineComponent } from 'vue';
    //import Patient from '../script/Patient';
    import Prat from '../script/Prat';
    import image from '../assets/flic32/icone/PNG/fisiorange.png'
    import Contrat from '../script/Contrat';
    import config from '../config';

    export default defineComponent({
        mounted() {
            // On initialise lesProd
            var lesProd = Prat.getLesProd();
            lesProd.then(response => {
                this.lesProd = response;
            })
            // On initialise lesNomPrat
            var lesNomPrat = Prat.GetNameOfPratBySearch("a");
            lesNomPrat.then(response => {
                this.lesNomPrat = response;
            });
            //Plancer le btn menu pour lorsq'on est sur un téléphone
            var theContainer = document.getElementById("theContainer");
            var menuBtn = document.getElementById("menuBtn");
            theContainer.style.left = window.innerWidth - menuBtn.offsetWidth - 10 + "px";

        },
        components: {
            //Les composants
        },
        data: function () {
            return {
                maxLength: 8,
                message: 'Bienvenue dans Flic32 !!',
                lesPrat: [],
                pratCourant: {},
                critere: "",
                num: "",
                lesProd: [],
                lesMod: [],
                produitChoisit: "",
                NUMERO_SERIE2: "",
                possede: []
                , img: "",
                nombre_de_postes: 0,
                debut_contrat: "",
                debut_periode: "",
                fin_periode: "",
                textCopier: "",
                NUMERO_LICENCE: "",
                NUMERO_SERIE : "",
                NOM_PRAT: "",
                lesNomPrat: [],
                contrat : {}
            }
        },

        computed: {
            licencePart1() {
                return this.getPartLicence(0, 8);
            },
            licencePart2() {
                return this.getPartLicence(9, 11);
            },
            licencePart3() {
                return this.getPartLicence(21, 4);
            },
            licencePart4() {
                return this.getPartLicence(26, 4);
            },
            modulePossede() {

            }
        },

        methods: {
            imprimer() {
                const content = this.getTextImpression();
                const encoder = new TextEncoder();
                const utf8Bytes = encoder.encode(content);
                const file = new Blob([utf8Bytes], { type: 'text/plain;charset=utf-8' });
                const fileURL = URL.createObjectURL(file);
                const printWindow = window.open(fileURL, '_blank');
                printWindow.addEventListener('load', () => {
                    printWindow.print();
                });
            },
            getTextImpression() {
                var content = "";
                content += "Client : " + this.pratCourant["NOM_PRAT"] + "\n"
                content += "\n"
                content += "Licence donnée le : " + this.getDateAndHour() + "\n";
                content += "\n"
                content += "Produit : " + this.produitChoisit + "\n"
                content += "\n"
                content += "Numéro de licence : " + this.NUMERO_LICENCE + "\n"
                content += "\n"
                content += "Numéro de série : " + this.NUMERO_SERIE + "\n";
                content += "\n"
                content += "Module: "
                content += "\t\t MODULE1"

                return content;
            },
            getDateAndHour() {
                let date = new Date();
                let jour = date.getDate();
                let mois = date.getMonth() + 1;
                let annee = date.getFullYear();
                let heure = date.getHours();
                let minutes = date.getMinutes();
                let secondes = date.getSeconds();

                // formatage des chiffres pour ajouter un 0 si nécessaire
                if (jour < 10) {
                    jour = "0" + jour;
                }
                if (mois < 10) {
                    mois = "0" + mois;
                }
                if (heure < 10) {
                    heure = "0" + heure;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (secondes < 10) {
                    secondes = "0" + secondes;
                }

                // Concaténation des éléments pour former la date et l'heure
                let dateEtHeure = jour + "/" + mois + "/" + annee + " " + heure + ":" + minutes + ":" + secondes;
                return dateEtHeure;
            },
            showMenu() {
                var theContainer = document.getElementById("theContainer");
                var menuBtn = document.getElementById("menuBtn");
                var path = document.getElementById("chevron").firstChild;
                var bool = theContainer.classList.toggle("show");
                if (bool) {
                    theContainer.style.left = window.innerWidth - theContainer.offsetWidth + "px";
                    path.setAttribute("d", "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z");
                }
                else {
                    theContainer.style.left = window.innerWidth - menuBtn.offsetWidth - 10 + "px";
                    path.setAttribute("d", "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z");
                }
            },
            oldShowMenu() {
                //let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300,left=100,top=100`;
                //open('/', 'test', params);
                var backgroundMenu = document.getElementById("flic32-background-menu");
                console.log(backgroundMenu);
                var shown = backgroundMenu.classList.toggle("show");
                if (shown) {
                    alert(document.body.style.overflow);
                    document.body.style.overflow = 'hidden';
                }
                else {
                    document.body.style.overflow = "";
                }

                var containerMenu = document.getElementById("flic32-container-btn-phone");
                shown = containerMenu.classList.toggle("show");
                const midX = window.innerWidth / 2; // get the midpoint along the x-axis
                const midY = window.innerHeight / 2; // get the midpoint along the y-axis

                //alert("midX=" + midX + "\nmidY=" + midY)
                containerMenu.style.left = midX - containerMenu.offsetWidth / 2 + 'px';
                containerMenu.style.top = midY - containerMenu.offsetHeight / 2 + 'px';

                    var closeMenu = document.getElementById("flic32-croix-closeMenu");
                closeMenu.classList.toggle("show");
                closeMenu.style.left = containerMenu.offsetLeft /*- closeMenu.offsetWidth/2*/ +"px";
                closeMenu.style.top = containerMenu.offsetTop /*- closeMenu.offsetHeight/2*/ + "px";

                var body = document.getElementsByName('body');
            },
            focusInput(input) {
                console.log(input);
            },
            selectModulePossede(index) {
                this.possede[index] = ! this.possede[index]
            },
            selectAllModules(bool) {
                for (var i = 0; i < this.possede.length; i++) 
                    this.possede[i] = bool;
            },
            ecrire() {
                var prat = {
                    NOM_PRAT: this.critere,
                    NUMERO_SERIE : this.NUMERO_SERIE,
                    NUMERO_LICENCE: this.NUMERO_LICENCE,
                    PRODUIT: this.produitChoisit,
                    NUM_CONTRAT: 0
                }
                console.log(prat);
                Prat.ecrire(prat)
                    .then(response => {
                        alert(response);
                    })
                    .catch(error => { alert(error) });
            },
            decodage() {
                if (this.NUMERO_LICENCE != "" && this.NUMERO_LICENCE != null) {
                    Prat.GetPratByNumLicence(this.NUMERO_LICENCE)
                        .then(response => {
                            this.critere = response.NOM_PRAT;
                            this.NOM_PRAT = this.critere;
                            this.produitChoisit = response.PRODUIT;

                            this.pratCourant = response;
                            this.updatePrat();
                            this.changerContratParNomEtProduit();
                            this.changerModule();
                        });
                }
            },
            codage() {
                if (this.NUMERO_SERIE.length != 8 || ! /^\d+$/.test(this.NUMERO_SERIE)) {
                    var inputNumSerie = document.getElementById("inputNumSerie");
                    inputNumSerie.focus();
                    alert("Numero de série incorrect");
                    return;
                }
                if (this.produitChoisit == "") {
                    var selectElement = document.querySelector(".select-produit");
                    selectElement.focus();
                    selectElement.autofocus = true;
                    console.log(selectElement.options);
                    alert("Veuillez choisir un produit");
                    return;
                }
                var possedeStr = "";
                for (var i = 0; i < 32; i++)
                    possedeStr += this.possede[i] ? 1 : 0;
                Prat.codage(this.NUMERO_SERIE, possedeStr, this.produitChoisit, "").then(response => {
                    this.NUMERO_LICENCE = response;
                    console.log(response);
                });
            },
            coller() {
                navigator.clipboard.readText().then(response => {
                    this.textCopier = response + 0;
                    this.NUMERO_LICENCE = response;
                });
                //this.textCopier = "Texte collé avec succé"
            },
            copier() {
                navigator.clipboard.writeText(this.NUMERO_LICENCE);
                alert(this.NUMERO_LICENCE);
            },
            toLeft() {
                this.NUMERO_SERIE = this.NUMERO_SERIE2
            },
            getPartLicence(debut, taille) {
                if (this.NUMERO_LICENCE != null)
                    return this.NUMERO_LICENCE.substr(debut, taille);
                else {
                    return "";
                }
            },
            afficherPratCourant() {
                var prat = this.$store.getters["flic32/getPratCourant"];
                console.log(prat);
            },
            initialiserLesPrat() {
                Prat.getAllPrat().then(response => { console.table(response); this.lesPrat = response })
            },
            changerProd() {

            },
            changerModule() {
                Prat.getLesModByProd(this.produitChoisit)
                    .then(response => {
                        this.lesMod = response;
                        this.changerModulePossede();
                    })
            },
            changerModulePossede() {
                //if(this.NUMERO_LICENCE)
                Prat.decodeLicenceForModule(this.NUMERO_LICENCE)
                    .then(response => {
                        //console.table(this.possede);
                        for (var i = 0; i < response.length; i++) {
                            this.possede[i] = response[i] === "0" ? false: true;
                        }
                    });
            },
            getPrat() {
                var prat = Prat.getPatientById(this.num);
                prat.then(response => {
                    console.log(response);
                });
            },
            chercher() {
                //this.$store.dispatch("flic32/setLesPratBySearch", this.critere);
                const critere  = this.critere == "" || this.critere == null ? "a" : this.critere; 
                var lesNomPrat = Prat.GetNameOfPratBySearch(critere);
                lesNomPrat.then(response => {
                    this.lesNomPrat = response;
                    console.table(this.lesNomPrat);
                });
                //console.log("On cherche!", this.$store.getters["flic32/getLesPrat"]);
            },
            showPrat() {
                var resultatRecherche = document.querySelector(".resultatRecherche");
                if (resultatRecherche.classList.toggle("show")) {
                    //console.log("Activé")
                    var inputRecherche = document.querySelector("#inputRechercheFlic32");
                    var labelFlic32 = document.querySelector(".flic32-label");
                    console.log(labelFlic32.offsetWidth);
                    //resultatRecherche.style.right = 
                    resultatRecherche.style.transform = "translate(" + labelFlic32.offsetWidth + "px," + inputRechercheFlic32.offsetHeight + "px)";
                    console.log(resultatRecherche.style.left); 
                    //console.log(inputRecherche.offsetWidth);

                    resultatRecherche.style.width = inputRecherche.offsetWidth + "px";
                    console.log("resultatRecherche" + resultatRecherche.offsetTop + "\ninputRechercheFlic32=" + inputRechercheFlic32.style.o);
                }
                else {
                    //console.log("Désactivé");
                }
            },
            setContratById(id) {
                this.$store.dispatch("flic32/setContratById", id);
                //this.$store.dispatch("flic32/setContratById", 266);
            },
            afficherContrat() {
                console.log(this.contrat);
                if (this.contrat != null) {
                    for (var item in this.contrat) {
                        console.log(item);
                    }
                }
                else {
                    console.log("contrat null");
                }
                //navigator.clipboard.writeText("J'ai copier de text");
            },
            changerContratParNom(nom) {
                this.critere = nom;
                this.NOM_PRAT = nom;
                this.changerPrat();
                this.changerContratParNomEtProduit();
                //this.changerModulePossede();
            },
            changerContratPar(produit) {
                this.produitChoisit = produit;
                this.changerPrat();
                this.changerContratParNomEtProduit();
            },
            changerPrat() {
                Prat.getPratByNameAndProd(this.NOM_PRAT, this.produitChoisit)
                    .then(response => {
                        this.pratCourant = response;
                        this.updatePrat();
                        this.changerContratParNomEtProduit();
                        this.changerModule();
                    });
            },
            changerContratParNomEtProduit() {
                var NUM_CONTRAT = this.pratCourant.NUM_CONTRAT;
                if (NUM_CONTRAT != null) {
                    Contrat.getContratById(NUM_CONTRAT)
                        .then(response => {
                            this.contrat = response;
                            this.updateContrat();
                            //this.changerModulePossede();
                        })
                }
                else {
                    this.contrat = {};
                }
            },
            updateContrat() {
                this.nombre_de_postes = this.contrat.nombre_de_postes;
                this.debut_contrat = this.contrat.debut_contrat;
                this.debut_periode = this.contrat.debut_periode;
                this.fin_periode = this.contrat.fin_periode;
                if (this.contrat.Chemin_icone != null) {
                    var nomImage = this.contrat.Chemin_icone.substr(0, this.contrat.Chemin_icone.length - 3) + "png"
                    this.img = require("../assets/flic32/icone/PNG/" + nomImage);
                }
                else {
                    this.img = "";
                }
            },
            updatePrat() {
                this.NUMERO_LICENCE = this.pratCourant.NUMERO_LICENCE;
                this.NUMERO_SERIE = this.pratCourant.NUMERO_SERIE != null ? this.pratCourant.NUMERO_SERIE : this.NUMERO_SERIE;
                //this.critere = this.pratCourant.NOM_PRAT;
                this.changerModulePossede();
            }
        },

        props: {

        },
        watch: {
            produitChoisit(newProduitChoisit) {
                 Prat.getLesModByProd(newProduitChoisit)
                    .then(response => {
                        this.lesMod = response;
                    });
                this.changerPrat();
                this.changerContratParNomEtProduit();
            },
            NUMERO_LICENCE(newValue, oldValue) {
            },
            possede(newValue, oldValue) {
            }
        }
    });
</script>
